// Pure helpers for the «Добавить расход» form (KOP-39 spec §5.4). No Vue, no axios.
import { isIsoDate } from './period';
import { toNumber } from './format';

export const DESCRIPTION_MAX = 500;

const text = (v) => (v === null || v === undefined ? '' : String(v)).trim();

export function emptyExpenseForm(today) {
  return { expense_date: today, amount: '', description: '' };
}

/** Ordered Russian messages; [] when the form is valid. UI rules are stricter than the API (spec §2 #7). */
export function validateExpenseForm(form) {
  const f = form || {};
  const errors = [];
  if (!isIsoDate(f.expense_date)) errors.push('Укажите дату расхода.');
  const amount = toNumber(f.amount);
  if (amount === null) errors.push('Укажите сумму.');
  else if (amount <= 0) errors.push('Сумма должна быть больше нуля.');
  else if (Math.abs(amount * 100 - Math.round(amount * 100)) > 1e-6) errors.push('Не более двух знаков после запятой.');
  const description = text(f.description);
  if (!description) errors.push('Укажите описание расхода.');
  else if (description.length > DESCRIPTION_MAX) errors.push(`Описание не длиннее ${DESCRIPTION_MAX} символов.`);
  return errors;
}

export function buildExpensePayload(form, geoLocationId) {
  return {
    geo_location_id: Number(geoLocationId),
    expense_date: form.expense_date,
    amount: Math.round(toNumber(form.amount) * 100) / 100,
    description: text(form.description),
  };
}
